import { Spin } from "antd";
import React, { Suspense, useCallback, useMemo } from "react";

import { useDispatch, useSelector } from "hooks/redux";
import { getVariablesFromUrl, updateUrlParams } from "state/url_params/utils";

import CategorySelector from "../annotations/CategorySelector";

import type { CSSProperties } from "react";

interface Props {
  onChanged?: (newVals: Array<string>) => void;
  className?: string;
  style?: CSSProperties;
  displayOrgTags?: boolean;
}

const key = "annotationsCategories";

export function useAnnotationsFromURL(): Array<string> | undefined {
  const rawValueJSON = useSelector(getVariablesFromUrl)[key];

  const value = useMemo(() => {
    return rawValueJSON != null ? (JSON.parse(rawValueJSON) as Array<string>) : undefined;
  }, [rawValueJSON]);
  return value;
}

const AnnotationCategoryFilter: React.FC<Props> = ({
  onChanged,
  className,
  style,
  displayOrgTags = true,
}) => {
  const dispatch = useDispatch();
  const value = useAnnotationsFromURL();

  const handleChange = useCallback(
    (value: Array<string>) => {
      // if nothing selected clear the url variable
      const adjustedVal = value.length === 0 ? undefined : value;
      adjustedVal && onChanged && onChanged(adjustedVal);
      dispatch(
        updateUrlParams({
          [key]: JSON.stringify(adjustedVal),
        })
      );
    },
    [onChanged, dispatch]
  );

  return (
    <Suspense fallback={<Spin />}>
      <CategorySelector
        value={value}
        onChange={handleChange}
        allowCreate={false}
        className={className}
        style={style}
        multiSelect={true}
        displayOrgTags={displayOrgTags}
      />
    </Suspense>
  );
};

export default AnnotationCategoryFilter;
